var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"default-expanded-keys":[],"default-checked-keys":_vm.defaultValue,"props":_vm.defaultProps,"show-checkbox":"","node-key":"id"},on:{"check":_vm.onCheck,"current-change":_vm.currentChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7456c3e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/CampusManagement/campusYun/components/catalog/components/treeBox/index.vue
// module id = null
// module chunks = 